import type { ApiResponse } from '@court-sync/shared';
import { apiGet } from './apiClient';

export interface UnifiedOccupancyCalendarItem {
  id: string;
  type: 'lesson_session' | 'closure';
  resourceType: 'court' | 'asset';
  resourceId: string;
  startAt: string;
  endAt: string;
  sourceType: string;
  sourceKey: string;
  sourceId?: string;
  bookedByAcademyId?: string;
  lessonId?: string;
  lessonName?: string;
}

export const occupancyService = {
  async getCalendar(
    clubId: string,
    from: string,
    to: string
  ): Promise<ApiResponse<UnifiedOccupancyCalendarItem[]>> {
    return apiGet<UnifiedOccupancyCalendarItem[]>('/occupancy', {
      params: { clubId, from, to },
    });
  },
};
